/**
 * @generated SignedSource<<d2d61ae6215fb98b8ed64caa34fbfe9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuildApprovalReviewers_groupApproval$data = {
  readonly currentlyApprovedBy: {
    readonly user: ReadonlyArray<{
      readonly id: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"BuildApprovalReviewers_approvalUser">;
    }> | null | undefined;
  } | null | undefined;
  readonly group: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly requiredApprovalsCount: number | null | undefined;
  readonly " $fragmentType": "BuildApprovalReviewers_groupApproval";
};
export type BuildApprovalReviewers_groupApproval$key = {
  readonly " $data"?: BuildApprovalReviewers_groupApproval$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuildApprovalReviewers_groupApproval">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuildApprovalReviewers_groupApproval",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Group",
      "kind": "LinkedField",
      "name": "group",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiredApprovalsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Users",
      "kind": "LinkedField",
      "name": "currentlyApprovedBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuildApprovalReviewers_approvalUser"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GroupApprovalRule",
  "abstractKey": null
};

(node as any).hash = "95d50823cb45363909bae43b0562438d";

export default node;
